<template>
  <div class="dialogCon" v-if="data.useDialog && data.message">
    <div class="layerPopup" :class="{ designPopup: data.useDesignPopup }">
      <div class="layerPopupMessage" v-html="data.message"></div>

      <div class="btn" v-if="!data.useDesignPopup">
        <a
          @click="
            data.getCloseButtonEvent();
            closePopup();
          "
        >
          {{ data.getCloseBtnName }}
        </a>

        <a
          v-if="data.getBtnCount === 2 && data.getBtnName"
          @click="
            data.getButtonEvent();
            closePopup();
          "
        >
          {{ data.getBtnName }}
        </a>
      </div>

      <div class="btn" v-else>
        <DesignButton
          :text="data.getCloseBtnName"
          size="x-small"
          @click="
            data.getCloseButtonEvent();
            closePopup();
          "
        />

        <DesignButton
          v-if="data.getBtnCount === 2 && data.getBtnName"
          :text="data.getBtnName"
          size="x-small"
          color="primary"
          @click="
            data.getButtonEvent();
            closePopup();
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import DesignButton from '@/components/DesignButton.vue';

export default {
  name: 'DialogPopup',
  components: {
    DesignButton
  },
  data() {
    return {
      data: {
        useDialog: false,
        message: '',
        getBtnCount: 1,
        getBtnName: '확인',
        getCloseBtnName: '',
        useDesignPopup: false,
        getButtonEvent: () => {},
        getCloseButtonEvent: () => {}
      }
    };
  },
  mounted() {
    const defaultData = () => {
      return {
        useDialog: false,
        message: '',
        getBtnCount: 1,
        getBtnName: '확인',
        getCloseBtnName: '',
        useDesignPopup: false,
        getCloseButtonEvent: () => {
          this.data.useDialog = false;
        },
        getButtonEvent: () => {
          this.data.useDialog = false;
        }
      };
    };
    this.data = defaultData();
    this.$mitt.on('DialogPopup', (val) => {
      try {
        this.data.useDialog = val.useDialog || defaultData().useDialog;
        this.data.message = val.message || defaultData().message;
        this.data.getBtnCount = val.getBtnCount || defaultData().getBtnCount;
        this.data.getBtnName = val.getBtnName || defaultData().getBtnName;
        this.data.getCloseButtonEvent = val.getCloseButtonEvent || defaultData().getCloseButtonEvent;
        this.data.getButtonEvent = val.getButtonEvent || defaultData().getButtonEvent;
        if (val.getCloseBtnName) {
          this.data.getCloseBtnName = val.getCloseBtnName;
        } else {
          this.data.getCloseBtnName = this.data.getBtnCount === 1 ? '확인' : '취소';
        }

        this.data.useDesignPopup = val.useDesignPopup || defaultData().useDesignPopup;
      } catch (e) {
        console.log(e);
      }
    });
  },
  methods: {
    closePopup() {
      this.data.useDialog = false;
    }
  }
};
</script>
